// Color palette and font stack for REMAX brand
export const COLORS = {
  primaryRed: '#ff1200',
  primaryBlue: '#0043ff',
  primaryDarkRed: '#660000',
  primaryDarkBlue: '#000e35',
  black: '#000000',
  white: '#ffffff',
  grey: '#f7f7f7', // Cream/grey for backgrounds
};

export const FONT_STACK = [
  'Montserrat',
  'Arial',
  'system-ui',
  'sans-serif',
];
